import { useRoutes } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ===========================|| ROUTING RENDER ||=========================== //

export default function ThemeRoutes() {
  // Filter MainRoutes base on Role and Software

  return useRoutes([LoginRoutes, MainRoutes]);
}
